import { render, staticRenderFns } from "./NftCollection.vue?vue&type=template&id=4073baaa"
import script from "./NftCollection.vue?vue&type=script&lang=js"
export * from "./NftCollection.vue?vue&type=script&lang=js"
import style0 from "./NftCollection.vue?vue&type=style&index=0&id=4073baaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports